"use strict";

exports.__esModule = true;
exports.AlertsContext = void 0;
var _AlertsController = require("./AlertsController");
var _Utils = require("../../../Utils");
/**
 * Provides a ticketing context to consumers
 * @component
 */
var AlertsContext = exports.AlertsContext = (0, _Utils.createEnhancedContext)({
  propName: "alerts",
  defaultController: _AlertsController.AlertsController
});